import { SideNavInterface } from "../../interfaces/side-nav.type";

export const CRM_FMARKET_SALE_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Nhà đầu tư",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "user",
    submenu: [
      {
        path: "/users/investor/all",
        title: "Tất cả",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "/users/investor/foreign",
        title: "NĐT nước ngoài",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
    ],
  },
  {
    path: "/users/transaction",
    title: "Lệnh chờ bán",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "transaction",
    submenu: [],
  },
  {
    path: "/users/investor-support",
    title: "Danh sách hỗ trợ",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "customer-service",
    submenu: [],
  },
  {
    path: "",
    title: "Giao dịch",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "reddit",
    submenu: [
      {
        path: "/users/orders-tracking",
        title: "Lệnh chờ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/sip-status-list",
        title: "Trạng thái SIP",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/orders-history",
        title: "Lịch sử giao dịch",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/transfer-money",
        title: "Log chuyển tiền",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/refund-request",
        title: "Hoàn tiền",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
    ],
  },
  {
    path: "/users/cs-rating",
    title: "CS Rating",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "star",
    submenu: [],
  },
  {
    path: "/users/feedback-of-customer",
    title: "User's Feedback",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "container",
    submenu: [],
  },
  {
    path: "/users/share-target",
    title: "Share mục tiêu",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "container",
    submenu: [],
  },
];

export const CRM_FMARKET_SALE_LEAD_ROUTES: SideNavInterface[] = [
  {
    path: "",
    title: "Nhà đầu tư",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "user",
    submenu: [
      {
        path: "/users/investor/all",
        title: "Tất cả",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
      {
        path: "/users/investor/foreign",
        title: "NĐT nước ngoài",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "user",
        submenu: [],
      },
    ],
  },
  {
    path: "/users/transaction",
    title: "Lệnh chờ bán",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "dollar",
    submenu: [],
  },
  {
    path: "/users/investor-support",
    title: "Danh sách hỗ trợ",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "customer-service",
    submenu: [],
  },
  {
    path: "",
    title: "OTP",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "message",
    submenu: [
      {
        path: "/users/otp-tracking",
        title: "OTP Tracking",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "customer-service",
        submenu: [],
      },
      {
        path: "/users/lock-phone-list",
        title: "SDT Lock",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "customer-service",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Giao dịch",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "transaction",
    submenu: [
      {
        path: "/users/orders-tracking",
        title: "Lệnh chờ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/sip-status-list",
        title: "Trạng thái SIP",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/orders-history",
        title: "Lịch sử giao dịch",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/transfer-money",
        title: "Log chuyển tiền",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
      {
        path: "/users/refund-request",
        title: "Hoàn tiền",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "search",
        submenu: [],
      },
    ],
  },
  {
    path: "/users/user-reward",
    title: "Reward",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "gift",
    submenu: [],
  },
  {
    path: "",
    title: "Thống kê",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "control",
    submenu: [
      {
        path: "/users/user-segment",
        title: "User Segment",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "control",
        submenu: [],
      },
      {
        path: "/users/first-buy-transaction",
        title: "Lệnh mua đầu tiên",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "control",
        submenu: [],
      },
      {
        path: "/users/statistic-time-holding",
        title: "Thời gian nắm giữ",
        iconType: "nzIcon",
        iconTheme: "outline",
        icon: "container",
        submenu: [],
      },
    ],
  },

  {
    path: "/users/cs-rating",
    title: "CS Rating",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "star",
    submenu: [],
  },
  {
    path: "/users/feedback-of-customer",
    title: "User's Feedback",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "container",
    submenu: [],
  },
  {
    path: "/users/share-target",
    title: "Share mục tiêu",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "container",
    submenu: [],
  },
];

export const CRM_LIFE_HERO_SALE_ROUTES: SideNavInterface[] = [
  {
    path: "/life-hero/request-assistance",
    title: "Phân công TC hỗ trợ",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "bell",
    submenu: [],
  },
  // {
  //   path: "/life-hero/assigned-assistance-for-organization",
  //   title: "Tổ chức được phân công",
  //   iconType: "",
  //   iconTheme: "outline",
  //   icon: "./assets/images/icons/ic-clipboard.svg",
  //   submenu: [],
  // },
  {
    path: "/life-hero/assigned-assistance-for-consultant",
    title: "Thông tin phân công",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "solution",
    submenu: [],
  },
  {
    path: "/life-hero/contract",
    title: "Hợp đồng",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "container",
    submenu: [],
  },
  {
    path: "/life-hero/assigned-rule",
    title: "Quy tắc phân công cho TC",
    iconType: "nzIcon",
    iconTheme: "outline",
    icon: "container",
    submenu: [],
  },
];
